
import { defineComponent, ref, watch, computed } from "vue";
import { Field, ErrorMessage } from "vee-validate";
import { numberFormatter } from "@/utils/index";
import moment from "moment";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";

export default defineComponent({
  name: "FundingRound",
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    formDataTemp: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const fundingRoundName = ref<string>("");
    const fundingRoundMinimumInvestment = ref<string>("");
    const fundingRoundPreMoneyValuation = ref<string>("");
    const fundingRoundInvestmentRequired = ref<string>("");
    const opensAt = ref<string>("");
    const closesAt = ref<string>("");
    const formData = ref<Record<string, unknown>>(props.formDataTemp);
    watch(
      () => props.formDataTemp,
      (value) => {
        formData.value = { ...value };
        fundingRoundName.value = (() => {
          if (fundingRoundName.value) {
            formData.value["fundingRoundName"] = fundingRoundName.value;
            return fundingRoundName.value;
          }
          return value?.fundingRoundName ?? "";
        })();
        fundingRoundMinimumInvestment.value = (() => {
          if (fundingRoundMinimumInvestment.value) {
            formData.value["fundingRoundMinimumInvestment"] =
              fundingRoundMinimumInvestment.value.replace(/,/g, "").toString();
            return fundingRoundMinimumInvestment.value;
          }
          return value?.fundingRoundMinimumInvestment ?? "";
        })();
        fundingRoundPreMoneyValuation.value = (() => {
          if (fundingRoundPreMoneyValuation.value) {
            formData.value["fundingRoundPreMoneyValuation"] =
              fundingRoundPreMoneyValuation.value.replace(/,/g, "").toString();
            return fundingRoundPreMoneyValuation.value;
          }
          return value?.fundingRoundPreMoneyValuation ?? "";
        })();
        fundingRoundInvestmentRequired.value = (() => {
          if (fundingRoundInvestmentRequired.value) {
            formData.value["fundingRoundInvestmentRequired"] =
              fundingRoundInvestmentRequired.value.replace(/,/g, "").toString();
            return fundingRoundInvestmentRequired.value;
          }
          return value?.fundingRoundInvestmentRequired ?? "";
        })();
        opensAt.value = (() => {
          if (opensAt.value) {
            formData.value["fundingRoundOpensAt"] = opensAt.value;
            return opensAt.value;
          }
          return value?.fundingRoundOpensAt ?? "";
        })();
        closesAt.value = (() => {
          if (closesAt.value) {
            formData.value["fundingRoundClosesAt"] = closesAt.value;
            return closesAt.value;
          }
          return value?.fundingRoundClosesAt ?? "";
        })();
      }
    );
    const formatter = numberFormatter;
    const dateCheck = computed(() => {
      if (opensAt.value && closesAt.value) {
        let areDatesValid = true;
        if (
          moment(opensAt.value).isValid() &&
          moment(closesAt.value).isValid() &&
          opensAtAdded.value &&
          closesAtAdded.value
        )
          areDatesValid = moment(opensAt.value) > moment(closesAt.value);
        emit("areDatesValid", areDatesValid);
        return areDatesValid;
      }
      emit("areDatesValid", true);
      return false;
    });
    const opensAtAdded = ref<boolean>(false);
    const closesAtAdded = ref<boolean>(false);
    watch(opensAt, (value) => {
      emit("opensAtAdded", value ? true : false);
      opensAtAdded.value = value ? true : false;
      if (moment(value).isValid())
        formData.value["fundingRoundOpensAt"] =
          moment(value).format("YYYY-MM-DD");
      else formData.value["fundingRoundOpensAt"] = "";
      emit("form-data", formData.value);
      createDraft();
    });
    watch(closesAt, (value) => {
      emit("closesAtAdded", value ? true : false);
      closesAtAdded.value = value ? true : false;
      if (moment(value).isValid())
        formData.value["fundingRoundClosesAt"] =
          moment(value).format("YYYY-MM-DD");
      else formData.value["fundingRoundClosesAt"] = "";
      emit("form-data", formData.value);
      createDraft();
    });
    const formatInput = (e) => {
      if (!e.target.value) {
        if (e.target.name == "fundingRoundInvestmentRequired")
          fundingRoundInvestmentRequired.value = "";
        if (e.target.name == "fundingRoundMinimumInvestment")
          fundingRoundMinimumInvestment.value = "";
        if (e.target.name == "fundingRoundPreMoneyValuation")
          fundingRoundPreMoneyValuation.value = "";
        return;
      }
      if (e.target.name == "fundingRoundInvestmentRequired")
        fundingRoundInvestmentRequired.value = formatter(
          parseFloat(e.target.value.replace(/,/g, "")).toString(),
          "en-US"
        );
      else if (e.target.name == "fundingRoundMinimumInvestment")
        fundingRoundMinimumInvestment.value = formatter(
          parseFloat(e.target.value.replace(/,/g, "")).toString(),
          "en-US"
        );
      else if (e.target.name == "fundingRoundPreMoneyValuation")
        fundingRoundPreMoneyValuation.value = formatter(
          parseFloat(e.target.value.replace(/,/g, "")).toString(),
          "en-US"
        );
    };
    const limitInput = (event) => {
      if (event.charCode < 48 || event.charCode > 57) {
        event.preventDefault();
      }
    };
    const fieldChanged = async (event) => {
      if (
        event.target.name == "fundingRoundInvestmentRequired" ||
        event.target.name == "fundingRoundMinimumInvestment" ||
        event.target.name == "fundingRoundPreMoneyValuation"
      ) {
        formData.value[event.target.name] = event.target.value.replace(
          /,/g,
          ""
        );
      } else {
        formData.value[event.target.name] = event.target.value;
      }
      emit("form-data", formData.value);
    };
    const createDraft = async () => {
      // try {
      //   const res = await store.dispatch(Actions.CREATE_BUSINESS_DRAFT, {
      //     business: JSON.stringify(formData.value),
      //   });
      //   if (res !== true) throw new Error("error in API");
      // } catch (err) {
      //   console.log({ err });
      // }
    };
    return {
      closesAtAdded,
      opensAtAdded,
      dateCheck,
      createDraft,
      limitInput,
      formData,
      fieldChanged,
      fundingRoundInvestmentRequired,
      fundingRoundMinimumInvestment,
      fundingRoundPreMoneyValuation,
      formatInput,
      opensAt,
      closesAt,
      fundingRoundName,
    };
  },
});
